import { Col, Row } from "react-grid-system";

import styled from "styled-components";

export const StyledUnitOverview = styled(Row)`
	p {
		font-size: 1.4rem;
		line-height: 1.6;
	}

	button {
		margin-top: 2rem;
	}
`;

export const StyledUnitOverviewTitle = styled(Col)`
	display: flex;
	align-items: center;
	margin-bottom: 1.2rem;
`;
